module.exports = __webpack_public_path__ + "img/14-1-2-1.5f9fdba4.png";